import { OnboardingStepProps } from '../types';
import { Button } from '../../buttons/Button';

import VsimavecHead from '../../../assets/vsimavec-head.svg';
import Owners from '../../../assets/zakladatele.jpg';

export function StepThankYou({ onNext }: OnboardingStepProps) {
    return (
        <>
            {/* Header */}
            <div className="text-center">
                <div className="mx-auto mb-6 w-20">
                    <img
                        src={VsimavecHead}
                        alt="Logo"
                        className="h-full w-full object-contain"
                    />
                </div>
                <h1 className="text-5xl">Děkujeme za&nbsp;registraci!</h1>
                <p className="mb-6 text-ink-800">
                    Nyní můžete do aplikace pozvat i své kolegy, abyste si
                    Všímavce vyzkoušeli společně.
                </p>
            </div>

            {/* Image */}
            <div className="flex flex-col gap-4">
                <h2 className="text-center text-3xl">
                    Pozvěte své kolegy do Všímavce
                </h2>

                <div className="overflow-hidden">
                    <img
                        src={Owners}
                        alt="Zakladatelé Všímavce"
                        className="h-full w-full object-cover"
                    />
                </div>

                <p className="text-center text-ink-800">
                    Nechcete-li teď nikoho přidávat, můžete to&nbsp;udělat kdykoli
                    později v&nbsp;menu →&nbsp;Organizace.
                </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-col w-full max-w-[540px] gap-2">
                <Button
                    color="product"
                    className="text-base"
                    onClick={() => onNext('invite')}
                    // className="bg-product-500 hover:bg-product-600 text-white font-bold text-[20px] w-[545px] h-[45px] rounded-[12px] transition-colors"
                >
                    Pozvat kolegy
                </Button>
                <Button
                    color="product"
                    variant="secondary"
                    className="text-base"
                    onClick={() => onNext('intro-video')}
                >
                    Pokračovat k aplikaci
                </Button>
            </div>
        </>
    );
}
